import React, { useState } from "react";
// Double check this path! If it's in the same folder, use "./data"
import { DesignData } from "../Components/data";

const DesignSection = ({ section }) => {
  const [selectedImg, setSelectedImg] = useState(null);

  // Safety: If section is missing, don't crash the app
  if (!section) return null;

  return (
    <div className="design-section">
      <h2 className="design-subtitle">{section.category}</h2>
      <p className="design-description">{section.description}</p>

      <div className="design-grid">
        {section.images &&
          section.images.map((img) => (
            <div
              key={img.id}
              className="design-image-box"
              onClick={() => setSelectedImg(img)}
              style={{ cursor: "pointer" }}
            >
              {img.thumb ? (
                <img src={img.thumb} alt={img.alt} />
              ) : (
                <span className="placeholder-text">{img.alt}</span>
              )}
            </div>
          ))}
      </div>

      {/* Lightbox Overlay */}
      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          {/* Close button is optional, since clicking the background closes it */}
          <span className="lightbox-close" onClick={() => setSelectedImg(null)}>
            &times;
          </span>

          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImg.full || selectedImg.thumb}
              alt={selectedImg.alt}
            />
            {selectedImg.alt && (
              <p className="lightbox-caption">{selectedImg.alt}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Design = () => {
  return (
    <div className="container">
      <header className="page-header">
        <h1 className="design-main-title" style={{ color: "#fff" }}>
          Design
        </h1>
      </header>

      {/* Added a safety check for the map */}
      {DesignData && DesignData.length > 0 ? (
        DesignData.map((item, index) => (
          <DesignSection key={index} section={item} />
        ))
      ) : (
        <p>No data found. Check your DesignData import.</p>
      )}
    </div>
  );
};

export default Design;
